import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { _serverUrl2 } from "../../../config";

export default function TeamInfo() {
  const ID = useParams().id;
  const history = useHistory();
  const [infoData, setInfoData] = useState([]);
  const [kullanici, setKullanici] = useState([]);
  const [kullaniciListe, setKullaniciListe] = useState([]);
  const getInfosFromNode = useCallback(async () => {
    await axios.get(_serverUrl2 + "/team/infoVeri/" + ID).then((res) => {
      console.log(res.data.rows);
      setInfoData(res.data.rows[0]);
      return;
    });

    await axios.get(_serverUrl2 + "/team/teamUyeKullaniciAdlari/" + ID).then((res) => {
      console.log(res.data.rows, "JHOLŞ");
      setKullanici(res.data.rows);
      return;
    });
    await axios.get(_serverUrl2 + "/team/teamUyeKullaniciAdlari").then((res) => {
      console.log(res.data.rows, "JHO232LŞ");
      setKullaniciListe(res.data.rows);
      return;
    });
  }, [ID]);

  const update = async () => {
    let json = {
      ekip_adi: document.getElementById("ekip_adi").value,
      ekip_aciklama: document.getElementById("ekip_aciklama").value,
      id: ID,
    };
    await axios.post(_serverUrl2 + "/team/updateInfo", json).then((res) => {
      console.log(res.data.rows, "update");
      history.push("/dashboard/team");
      return;
    });
  };

  const gorev = (e) => {
    if (e == 0) {
      document.getElementById("gorevler").style.display = "none";
      document.getElementById("yenigorev").style.display = "block";
    } else {
      document.getElementById("gorevler").style.display = "block";
      document.getElementById("yenigorev").style.display = "none";
    }
  };

  const uyeEkelemeForm = (e) => {
    if (e == 0) {
      document.getElementById("ekipUyeleri").style.display = "none";
      document.getElementById("ekipUyeleriEkle").style.display = "block";
    } else {
      document.getElementById("ekipUyeleri").style.display = "block";
      document.getElementById("ekipUyeleriEkle").style.display = "none";
    }
  };
  useEffect(() => {
    getInfosFromNode();
  }, [getInfosFromNode]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox" style={{ textAlign: "center", borderLeft: "10px solid #007095", backgroundColor: "rgba(255,165,0,0.05)" }}>
          <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
            <tbody>
              <tr>
                <th colSpan={3} style={{ borderRadius: "5px", marginTop: "10px", backgroundColor: "#007095", color: "white" }}>
                  Ekip Bilgileri
                </th>
              </tr>
              <tr>
                <th>Ekip Adı</th>
                <td>
                  <input id="ekip_adi" defaultValue={infoData.ekip_adi}></input>
                </td>
              </tr>
              <tr>
                <th>Açıklama</th>
                <td>
                  <input id="ekip_aciklama" defaultValue={infoData.ekip_aciklama}></input>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <button className="orangeBtn" onClick={() => history.goBack()} style={{ width: "20%", fontSize: "10px" }}>
                    Geri
                  </button>
                  <button className="blueBtn" style={{ width: "25%", fontSize: "10px", marginLeft: "20px" }} onClick={(e) => update(e)}>
                    Kaydet
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="col-sm-12">
        <div
          className="textBox"
          style={{ textAlign: "center", borderLeft: "10px solid #125456", backgroundColor: "rgba(255,165,0,0.05)", display: "block" }}
          id="ekipUyeleri"
        >
          <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
            <tbody>
              <tr>
                <th colSpan={3} style={{ backgroundColor: "#125456", color: "white" }}>
                  Ekip Üyeleri
                </th>
              </tr>
              <tr>
                <th>Kullanıcı Adı</th>
                <th>İsim Soyisim</th>
                <th>
                  <button className="blueBtn" style={{ width: "75%", fontSize: "10px" }} onClick={() => uyeEkelemeForm(0)}>
                    Ekle
                  </button>
                </th>
              </tr>
              {kullanici.map((d) => {
                return (
                  <tr>
                    <td>{d.kullanici_adi}</td>
                    <td>{d.isim_soyisim}</td>
                    <td>
                      <button className="orangeBtn" style={{ width: "75%", fontSize: "10px" }}>
                        Profil
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-sm-12">
        <div
          className="textBox"
          id="ekipUyeleriEkle"
          style={{ textAlign: "center", borderLeft: "10px solid #125456", backgroundColor: "rgba(255,165,0,0.05)", display: "none" }}
        >
          <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
            <tbody>
              <tr>
                <th colSpan={2} style={{ backgroundColor: "#125456", color: "white" }}>
                  Ekip Üyesi Ekle
                </th>
              </tr>
              <tr>
                <th>Kullanıcı Adı</th>
                <td>
                  <select style={{ width: "100%" }}>
                    <option value="0" disabled selected>
                      Kullanıcı Seçiniz
                    </option>
                    {kullaniciListe.map((d, i) => {
                      return (
                        <option key={i} value={d.id}>
                          {d.kullanici_adi}
                        </option>
                      );
                    })}
                  </select>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <button className="orangeBtn" style={{ width: "25%", fontSize: "10px" }} onClick={() => uyeEkelemeForm(1)}>
                    Geri
                  </button>
                  <button className="blueBtn" style={{ width: "25%", fontSize: "10px", marginLeft: "20px" }}>
                    Ekibe Ekle
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="col-sm-12">
        <div
          className="textBox"
          id="gorevler"
          style={{ textAlign: "center", borderLeft: "10px solid #541541", backgroundColor: "rgba(255,165,0,0.05)", display: "none" }}
        >
          <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
            <tbody>
              <tr>
                <th colSpan={4} style={{ backgroundColor: "#541541", color: "white" }}>
                  Görevler
                </th>
              </tr>
              <tr>
                <th>Kullanıcı Adı</th>
                <th>İsim Soyisim</th>
                <th>Görev</th>
                <th>
                  <button className="blueBtn" style={{ width: "75%", fontSize: "10px" }} onClick={() => gorev(0)}>
                    Ekle
                  </button>
                </th>
              </tr>
              <tr>
                <td>AD</td>
                <td>İsim Soyisim</td>
                <td>Görev</td>
                <td>
                  <button className="orangeBtn" style={{ width: "75%", fontSize: "10px" }}>
                    Profil
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-sm-12">
        <div
          className="textBox"
          id="yenigorev"
          style={{ textAlign: "center", borderLeft: "10px solid #5e3a36", backgroundColor: "rgba(255,165,0,0.05)", display: "none" }}
        >
          <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
            <tbody>
              <tr>
                <th colSpan={2} style={{ backgroundColor: "#5e3a36", color: "white" }}>
                  Görevler
                </th>
              </tr>
              <tr>
                <th>Kullanıcı Adı</th>
                <td>
                  <input></input>
                </td>
              </tr>
              <tr>
                <th>Görev</th>
                <td>
                  <input></input>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <button className="orangeBtn" style={{ width: "25%", fontSize: "10px" }} onClick={() => gorev(1)}>
                    Geri
                  </button>
                  <button className="blueBtn" style={{ width: "25%", fontSize: "10px", marginLeft: "20px" }}>
                    Görev Ekle
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
